import { computed } from 'vue'
import { useAuthStore } from '@/features/auth/stores/auth.store'

export function useAuth() {
  const store = useAuthStore()

  const isAuthenticated = computed(() => store.isAuthenticated)

  return {
    isAuthenticated,
    login: store.login,
    logout: store.logout,
    renewSession: store.renewSession,
  }
}
